var _mask, _path, _path2, _rect, _path3, _path4, _ellipse, _ellipse2, _ellipse3, _g, _ellipse4, _ellipse5, _g2, _rect2, _rect3, _rect4, _rect5, _path5, _path6, _ellipse6, _rect6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTimer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 88,
    viewBox: "0 0 72 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-outside-1_578_1700",
    maskUnits: "userSpaceOnUse",
    x: 0.476562,
    y: 0,
    width: 72,
    height: 88,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 0.476562,
    width: 72,
    height: 88
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.0338 5C27.9919 5 26.3366 6.65528 26.3366 8.69717C26.3366 10.7391 27.9919 12.3943 30.0338 12.3943H31.221C30.9582 12.8403 30.8074 13.3602 30.8074 13.9153V15.7922C16.4218 18.2483 5.47656 30.69 5.47656 45.6689C5.47656 55.6194 10.3066 64.4503 17.7668 69.9779L13.9933 76.4647C12.9608 78.2397 13.5681 80.5063 15.3498 81.5272C17.1315 82.5481 19.4129 81.9369 20.4454 80.1619L24.2356 73.6462C27.8626 75.1532 31.8446 75.9857 36.0225 75.9857C40.1225 75.9857 44.0339 75.184 47.6061 73.7299L51.3476 80.1618C52.3802 81.9369 54.6616 82.5481 56.4433 81.5272C58.225 80.5062 58.8323 78.2397 57.7997 76.4647L54.1018 70.1077C61.6621 64.5891 66.5685 55.6976 66.5685 45.6689C66.5685 30.69 55.6234 18.2483 41.2378 15.7922V13.9153C41.2378 13.3602 41.087 12.8403 40.8242 12.3943H42.01C44.0519 12.3943 45.7072 10.7391 45.7072 8.69717C45.7072 6.65528 44.0519 5 42.01 5H30.0338Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.0338 5C27.9919 5 26.3366 6.65528 26.3366 8.69717C26.3366 10.7391 27.9919 12.3943 30.0338 12.3943H31.221C30.9582 12.8403 30.8074 13.3602 30.8074 13.9153V15.7922C16.4218 18.2483 5.47656 30.69 5.47656 45.6689C5.47656 55.6194 10.3066 64.4503 17.7668 69.9779L13.9933 76.4647C12.9608 78.2397 13.5681 80.5063 15.3498 81.5272C17.1315 82.5481 19.4129 81.9369 20.4454 80.1619L24.2356 73.6462C27.8626 75.1532 31.8446 75.9857 36.0225 75.9857C40.1225 75.9857 44.0339 75.184 47.6061 73.7299L51.3476 80.1618C52.3802 81.9369 54.6616 82.5481 56.4433 81.5272C58.225 80.5062 58.8323 78.2397 57.7997 76.4647L54.1018 70.1077C61.6621 64.5891 66.5685 55.6976 66.5685 45.6689C66.5685 30.69 55.6234 18.2483 41.2378 15.7922V13.9153C41.2378 13.3602 41.087 12.8403 40.8242 12.3943H42.01C44.0519 12.3943 45.7072 10.7391 45.7072 8.69717C45.7072 6.65528 44.0519 5 42.01 5H30.0338Z",
    fill: "#2BC76A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.221 12.3943L35.5286 14.933L39.9714 7.39434H31.221V12.3943ZM30.8074 15.7922L31.6489 20.7209L35.8074 20.0109V15.7922H30.8074ZM17.7668 69.9779L22.0887 72.4921L24.3386 68.6244L20.7435 65.9606L17.7668 69.9779ZM13.9933 76.4647L9.67138 73.9506H9.67138L13.9933 76.4647ZM15.3498 81.5272L12.8639 85.8654L12.8639 85.8654L15.3498 81.5272ZM20.4454 80.1619L24.7673 82.676L24.7673 82.676L20.4454 80.1619ZM24.2356 73.6462L26.1541 69.0289L22.1137 67.3502L19.9137 71.1321L24.2356 73.6462ZM47.6061 73.7299L51.928 71.2157L49.744 67.4612L45.721 69.0988L47.6061 73.7299ZM51.3476 80.1618L47.0257 82.676L51.3476 80.1618ZM56.4433 81.5272L53.9574 77.1889L53.9574 77.1889L56.4433 81.5272ZM57.7997 76.4647L62.1217 73.9506L62.1217 73.9505L57.7997 76.4647ZM54.1018 70.1077L51.1539 66.0692L47.5137 68.7263L49.7799 72.6218L54.1018 70.1077ZM41.2378 15.7922H36.2378V20.0109L40.3963 20.7209L41.2378 15.7922ZM40.8242 12.3943V7.39434H32.0738L36.5166 14.933L40.8242 12.3943ZM31.3366 8.69717C31.3366 9.41671 30.7533 10 30.0338 10V0C25.2305 0 21.3366 3.89385 21.3366 8.69717H31.3366ZM30.0338 7.39434C30.7533 7.39434 31.3366 7.97763 31.3366 8.69717H21.3366C21.3366 13.5005 25.2305 17.3943 30.0338 17.3943V7.39434ZM31.221 7.39434H30.0338V17.3943H31.221V7.39434ZM26.9134 9.85572C26.2097 11.0498 25.8074 12.4432 25.8074 13.9153H35.8074C35.8074 14.2772 35.7067 14.6308 35.5286 14.933L26.9134 9.85572ZM25.8074 13.9153V15.7922H35.8074V13.9153H25.8074ZM29.966 10.8635C13.2459 13.7181 0.476562 28.1853 0.476562 45.6689H10.4766C10.4766 33.1946 19.5976 22.7784 31.6489 20.7209L29.966 10.8635ZM0.476562 45.6689C0.476562 57.2795 6.11958 67.5708 14.7901 73.9953L20.7435 65.9606C14.4937 61.3297 10.4766 53.9594 10.4766 45.6689H0.476562ZM13.4448 67.4638L9.67138 73.9506L18.3153 78.9788L22.0887 72.4921L13.4448 67.4638ZM9.67138 73.9506C7.24392 78.1235 8.6752 83.4652 12.8639 85.8654L17.8357 77.189C18.461 77.5473 18.6776 78.3559 18.3153 78.9788L9.67138 73.9506ZM12.8639 85.8654C17.0305 88.253 22.3527 86.8269 24.7673 82.676L16.1235 77.6477C16.4731 77.0468 17.2325 76.8433 17.8357 77.189L12.8639 85.8654ZM24.7673 82.676L28.5576 76.1604L19.9137 71.1321L16.1235 77.6477L24.7673 82.676ZM22.3172 78.2636C26.542 80.0189 31.1753 80.9857 36.0225 80.9857V70.9857C32.5139 70.9857 29.1831 70.2875 26.1541 69.0289L22.3172 78.2636ZM36.0225 80.9857C40.7792 80.9857 45.33 80.0547 49.4912 78.3609L45.721 69.0988C42.7377 70.3132 39.4658 70.9857 36.0225 70.9857V80.9857ZM43.2841 76.244L47.0257 82.676L55.6696 77.6477L51.928 71.2157L43.2841 76.244ZM47.0257 82.676C49.4404 86.8269 54.7626 88.253 58.9292 85.8654L53.9574 77.1889C54.5606 76.8433 55.32 77.0468 55.6696 77.6477L47.0257 82.676ZM58.9292 85.8654C63.1179 83.4652 64.5491 78.1235 62.1217 73.9506L53.4778 78.9788C53.1154 78.3559 53.3321 77.5473 53.9574 77.1889L58.9292 85.8654ZM62.1217 73.9505L58.4237 67.5936L49.7799 72.6218L53.4778 78.9788L62.1217 73.9505ZM57.0497 74.1462C65.8364 67.7325 71.5685 57.371 71.5685 45.6689H61.5685C61.5685 54.0243 57.4879 61.4457 51.1539 66.0692L57.0497 74.1462ZM71.5685 45.6689C71.5685 28.1854 58.7993 13.7182 42.0793 10.8635L40.3963 20.7209C52.4475 22.7785 61.5685 33.1946 61.5685 45.6689H71.5685ZM46.2378 15.7922V13.9153H36.2378V15.7922H46.2378ZM46.2378 13.9153C46.2378 12.4432 45.8355 11.0498 45.1318 9.85572L36.5166 14.933C36.3385 14.6308 36.2378 14.2772 36.2378 13.9153H46.2378ZM42.01 7.39434H40.8242V17.3943H42.01V7.39434ZM40.7072 8.69717C40.7072 7.97763 41.2905 7.39434 42.01 7.39434V17.3943C46.8133 17.3943 50.7072 13.5005 50.7072 8.69717H40.7072ZM42.01 10C41.2905 10 40.7072 9.41671 40.7072 8.69717H50.7072C50.7072 3.89385 46.8133 0 42.01 0V10ZM30.0338 10H42.01V0H30.0338V10Z",
    fill: "#41403F",
    mask: "url(#path-1-outside-1_578_1700)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 41.2383,
    y: 10.9155,
    width: 8.13378,
    height: 10.4303,
    rx: 3,
    transform: "rotate(90 41.2383 10.9155)",
    fill: "#0E7A3A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5938 73.0278L20.4438 80.1618C19.4113 81.9368 17.1299 82.5481 15.3482 81.5271C13.5665 80.5062 12.9592 78.2396 13.9917 76.4646L18.1417 69.3307L24.5938 73.0278Z",
    fill: "#0E7A3A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6504 69.3306L57.8003 76.4645C58.8329 78.2395 58.2255 80.5061 56.4439 81.527C54.6622 82.548 52.3808 81.9367 51.3482 80.1617L47.1983 73.0277L53.6504 69.3306Z",
    fill: "#0E7A3A"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.0225,
    cy: 45.6688,
    rx: 30.546,
    ry: 30.3168,
    fill: "#17B256"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.0222,
    cy: 45.6691,
    rx: 25.3308,
    ry: 25.1408,
    fill: "#6CF1A2"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_578_1700",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 20,
    width: 52,
    height: 51
  }, _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.3181,
    cy: 25.1535,
    rx: 25.3181,
    ry: 25.1535,
    transform: "matrix(-0.96641 -0.257006 0.260643 -0.965435 53.9355 76.46)",
    fill: "#6CF1A2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_578_1700)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 47.6576,
    cy: 47.3478,
    rx: 47.6576,
    ry: 47.3478,
    transform: "matrix(-0.96641 -0.257006 0.260643 -0.965435 88.127 138.374)",
    fill: "black",
    fillOpacity: 0.13
  }))), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.0229,
    cy: 45.6691,
    rx: 19.3706,
    ry: 19.2253,
    fill: "#D3F9E2"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_578_1700",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 26,
    width: 40,
    height: 39
  }, _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.022,
    cy: 45.6688,
    rx: 19.3706,
    ry: 19.2253,
    transform: "rotate(-180 36.022 45.6688)",
    fill: "#FDFFFE"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_578_1700)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.022,
    cy: 59.7181,
    rx: 19.3706,
    ry: 19.2253,
    transform: "rotate(-180 36.022 59.7181)",
    fill: "#FDFFFE"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 37.5137,
    y: 26.4434,
    width: 5.17604,
    height: 2.98009,
    rx: 1.49005,
    transform: "rotate(90 37.5137 26.4434)",
    fill: "#0E7A3A"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 37.5137,
    y: 59.7183,
    width: 5.17604,
    height: 2.98009,
    rx: 1.49005,
    transform: "rotate(90 37.5137 59.7183)",
    fill: "#0E7A3A"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 55.3926,
    y: 47.1479,
    width: 5.21516,
    height: 2.95774,
    rx: 1.47887,
    transform: "rotate(-180 55.3926 47.1479)",
    fill: "#0E7A3A"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 21.8652,
    y: 47.1479,
    width: 5.21516,
    height: 2.95774,
    rx: 1.47887,
    transform: "rotate(-180 21.8652 47.1479)",
    fill: "#0E7A3A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3015 35.7129C46.9042 36.3111 46.9663 37.2602 46.4466 37.9308L39.0901 47.4224C37.8863 48.9756 35.5809 49.1242 34.1848 47.7386C32.7887 46.353 32.9385 44.0649 34.5034 42.8701L44.0668 35.5688C44.7425 35.053 45.6988 35.1146 46.3015 35.7129Z",
    fill: "#17B256"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7455 38.1917C28.1522 37.7881 28.7996 37.7525 29.2488 38.1089L37.1779 44.4011C38.23 45.236 38.3171 46.7932 37.3646 47.7386C36.4121 48.684 34.843 48.5975 34.0018 47.5533L27.6621 39.6837C27.3029 39.2379 27.3389 38.5954 27.7455 38.1917Z",
    fill: "#17B256"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.022,
    cy: 45.6688,
    rx: 3.72512,
    ry: 3.69717,
    fill: "#0E7A3A"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 26.3359,
    y: 5,
    width: 19.3706,
    height: 7.39434,
    rx: 3.69717,
    fill: "#2BC76A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimer);
export default __webpack_public_path__ + "static/media/timer.63531123a15d9b7b203a54a1aab3f0b8.svg";
export { ForwardRef as ReactComponent };